import { MetaFootballModel } from "../../../../models";
import ListContentModel from "./ListContentModel";

export default class ListContentResponseModel {
  public meta: MetaFootballModel = new MetaFootballModel();
  public data: ListContentModel[] = [];
}
